/* eslint-disable jquery/no-text */
/* eslint-disable jquery/no-css */
/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable camelcase */
import classNames from 'classnames';
import $ from 'jquery';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Dotdotdot from 'react-dotdotdot';
import { compose } from 'redux';

import { withTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

/**
 * @deprecated - only used on old HAML Public Homepage
 */
class EventCard extends Component {
  componentDidMount() {
    $(this.eventTitle).css('opacity', 1);
  }

  renderLocation = () => {
    const { locations } = this.props;

    if (Array.isArray(locations) && locations.length > 0) {
      const location = [locations[0].city, locations[0].country].filter(
        Boolean,
      );

      if (location.length > 0) {
        return (
          <div className="soft-quarter--top">
            <span className="soft-quarter--right">
              <i className="icon-map-marker" />
            </span>
            {location.join(', ')}
          </div>
        );
      }
    }

    return null;
  };

  renderCategories = () =>
    this.props.network_categories.slice(0, 2).map((c, i) => {
      if (i === 1) {
        return <a key={c.name}>{` — ${c.name}`}</a>;
      }

      return <a key={c.name}>{c.name}</a>;
    });

  render() {
    const {
      currentUser,
      id,
      title,
      start_date,
      timezone,
      customClassNames,
      cover_picture_medium,
      cover_picture_medium_url,
      network_categories,
      whitelabelURL,
      networkRootUrl,
      topicId,
      handlerOnClick,
    } = this.props;
    const linkProps = {};

    if (handlerOnClick) {
      linkProps.role = 'button';
    } else {
      linkProps.href = whitelabelURL ? networkRootUrl : '';

      if (topicId && !currentUser) {
        linkProps.href += Routes.network_event_path(id, {
          topic_id: topicId,
        });
      } else {
        linkProps.href += Routes.network_events_event_path(id);
      }
    }

    return (
      <div
        className={classNames('grid__item palm--one-whole', customClassNames)}
      >
        <div className="cover-bloc-item--event push--bottom">
          <a
            {...linkProps}
            onClick={() => {
              if (handlerOnClick) {
                handlerOnClick();
              }
            }}
          >
            <div
              className="cover-bloc-item__image"
              style={{
                backgroundImage: `url('${
                  cover_picture_medium_url ?? cover_picture_medium
                }')`,
              }}
            />
          </a>
          <div className="cover-bloc-item__footer">
            <a
              {...linkProps}
              className="cover-bloc-item__info"
              onClick={() => {
                if (handlerOnClick) {
                  handlerOnClick();
                }
              }}
            >
              <h4 className="h4" ref={(ref) => (this.eventTitle = ref)}>
                <Dotdotdot useNativeClamp clamp={3}>
                  {title}
                </Dotdotdot>
              </h4>
              <div className="soft-quarter--top">
                <span className="soft-quarter--right">
                  <i className="icon-calendar" />
                </span>
                {moment.tz(start_date, timezone).format('LLL')}
              </div>
              {this.renderLocation()}
            </a>

            {network_categories.length > 0 && (
              <div
                className="cover-bloc-item__tags"
                ref={(ref) => (this.tagsContainer = ref)}
              >
                <span className="soft-quarter--right">
                  <i className="icon-tag" />
                </span>
                {this.renderCategories()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

EventCard.propTypes = {
  customClassNames: PropTypes.string,
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  cover_picture_medium_url: PropTypes.string.isRequired,
  start_date: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      city: PropTypes.string,
      country: PropTypes.string.isRequired,
    }),
  ),
  network_categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  handlerOnClick: PropTypes.func,
};

EventCard.defaultProps = {
  customClassNames: 'one-half',
  locations: [],
  network_categories: [],
};

export default compose(withDefaultAppContexts, withTopicContext)(EventCard);
